module.exports = __webpack_public_path__ + "static/media/TitleLarge.ecf50d78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oem/TitleLarge.png
// module id = 241
// module chunks = 0